import React from 'react';
import config from '../config';
import './TopBar.css';

export default function TopBar() {
  return (
    <header className="top-bar">
      <span className="top-bar__wordmark">{config.BRAND}</span>
      <span className="top-bar__badge">{config.EVENT_NAME}</span>
    </header>
  );
}
